export default __webpack_public_path__ + "static/media/emptystar.6ddaffb1.svg";